var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiaperDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.414,
    height: 38.414,
    viewBox: "0 0 38.414 38.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "diaper-disable",
    transform: "translate(-699.995 -281.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_6588580_and_baby_diaper_nappies_toys_icon",
    "data-name": "6588580_and_baby_diaper_nappies_toys_icon",
    transform: "translate(701 284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_6588580_and_baby_diaper_nappies_toys_icon-2",
    "data-name": "6588580_and_baby_diaper_nappies_toys_icon",
    d: "M28.7,16.681a1.271,1.271,0,0,1-1.271-1.409V11.045A1.271,1.271,0,0,1,28.7,9.636h8.772A6.6,6.6,0,0,0,31.24,4H8.356A6.6,6.6,0,0,0,2.127,9.636H10.9a1.271,1.271,0,0,1,1.271,1.409v4.227A1.271,1.271,0,0,1,10.9,16.681H2V18.09C2,27.248,7.594,34.856,15.222,37.11c.127,0,.254.141.381.141a13.783,13.783,0,0,0,4.2.564,19.678,19.678,0,0,0,4.139-.564c.127,0,.685-.278.812-.278C32.378,34.719,37.6,27.389,37.6,18.23V16.821H28.7ZM4.924,21.612a19.366,19.366,0,0,1,9.153,12.117A16.362,16.362,0,0,1,4.924,21.612ZM25.646,33.729A19.366,19.366,0,0,1,34.8,21.612,16.973,16.973,0,0,1,25.646,33.729Z",
    transform: "translate(-2 -4)",
    fill: "#9a9a9a"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_249",
    "data-name": "Line 249",
    x1: 37,
    y2: 37,
    transform: "translate(700.702 282.5)",
    fill: "none",
    stroke: "#848484",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiaperDisable);
export default __webpack_public_path__ + "static/media/diaper-disable.c4540ce13be20c74c92df78484e1ba03.svg";
export { ForwardRef as ReactComponent };